import { Center, Spinner, Text } from "@chakra-ui/react";
import { Navigate } from "react-router-dom";

export default function Callback() {
    return (
        <Center flex={1} flexDir='column'>
            <Spinner />
            <Text>Redirecting...</Text>
            <Navigate to='/' replace />
        </Center>
    )
}